var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaceholder = function SvgPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 102,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.441 37.664H119.45M26.992 6.182H105.9",
    stroke: "currentColor",
    strokeOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.029 79.11V50.47L106.804 6.858S102.898 1 95.738 1H37.155c-7.16 0-11.066 5.858-11.066 5.858L7.863 50.47v28.64",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.029 76.719v11.704c0 7.152-5.918 13.004-13.151 13.004s-13.151-5.852-13.151-13.004l.041-9.771M34.166 78.704v9.719c0 7.152-5.918 13.004-13.151 13.004-7.234 0-13.152-5.852-13.152-13.004V76.719M16.415 29.997 11.962 40.44S1 36.906.722 34.669c-.28-2.238 1.776-4.23 1.776-4.23l13.917-.442ZM116.998 30.14l3.93 10.362s10.898-3.724 11.138-5.966c.24-2.241-1.85-4.197-1.85-4.197l-13.218-.2ZM8.209 78.713H125.02",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m36.447 45.72-22.436-3.273s-1.366 1.749-1.366 5.028c0 3.28 1.366 5.026 1.366 5.026l11.78 2.897s6.829-5.363 9.727-5.363h4.102l-3.173-4.316ZM97.115 45.72l22.436-3.273s1.367 1.749 1.367 5.028c0 3.28-1.367 5.026-1.367 5.026l-11.779 2.897s-6.829-5.363-9.728-5.363h-4.102l3.173-4.316Z",
    stroke: "currentColor",
    strokeOpacity: 0.65
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.746 50.018h55.27",
    stroke: "currentColor"
  })));
};
export default SvgPlaceholder;